import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Studio from "@/components/Studio";
import Treatments from "@/components/Treatments";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <Studio />
      <Treatments />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
